import { render, staticRenderFns } from "./MyBreadcrumb.vue?vue&type=template&id=6b188530&scoped=true&"
import script from "./MyBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./MyBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./MyBreadcrumb.vue?vue&type=style&index=0&id=6b188530&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b188530",
  null
  
)

export default component.exports